import Shepherd from "shepherd.js";
import {getToken} from "@/helpers/auth/auth-helper";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper.js";
import {isVisibleBySelector} from "@/helpers/element-helper.js";

export function startTour(id, step = undefined) {

    let tour = new Shepherd.Tour({
        useModalOverlay: true,
        defaultStepOptions: {
            scrollTo: {
                behavior: 'smooth',
                block: 'center',
            },
            cancelIcon: {
                enabled: true,
            },
            showOn() {

                if (!this.attachTo) {
                    return true;
                }

                const element = document.querySelector(this.attachTo.element);

                if(element && element.tagName.toLowerCase().includes('layer-menu')) {
                    return true;
                }

                return !(!element || element.offsetHeight === 0);
            },
        }
    });

    switch (parseInt(id)) {
        case 1:
            tour = stepsNavigation(tour, step)
            break;
        case 2:
            tour = stepsCatalogus(tour, step)
            break;
        case 3:
            tour = stepsBottomButtons(tour, step)
            break;
        case 4:
            tour = stepsRightButtons(tour, step)
            break;
        default:
            tour = stepCompleteTour(tour)
            tour = stepsNavigation(tour, step, true)
            tour = stepsCatalogus(tour, step, true)
            tour = stepsBottomButtons(tour, step, true)
            tour = stepsRightButtons(tour, step, true)
            break;
    }

    tour.start()
}

export function stepsNavigation(tour, step = undefined, completeTour = false) {
    let last = true
    let first = true

    if (completeTour) {
        first = false
        last = false
    }

    if (!step || step === 1) {
        tour.addStep({
            title: 'Catalogus',
            text: 'Met deze knop klap je de catalogus in of uit. Hier vind je alle beschikbare kaartlagen van de website.',
            attachTo: {
                element: 'header-layer',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, step, first),
        });
    }


    if (!step || step === 2) {
        tour.addStep({
            title: 'Huisje',
            text: 'Klik op het huisje om de pagina te herladen. Dit werkt hetzelfde als F5.',
            attachTo: {
                element: 'header-home',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 3) {
        tour.addStep({
            title: 'Zoekbalk',
            text: 'Gebruik de zoekbalk om direct op een adres te zoeken. Daarnaast zit er onder de drie puntjes de optie om te zoeken op perceel of coördinaat.',
            attachTo: {
                element: 'header-search',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 4) {
        tour.addStep({
            title: 'Favoriete filters',
            text: 'Vanuit hier kan je een filter opstarten, meestal staan hier de meest gebruikte die door een beheerder zijn ingesteld. Dit is één van de manieren om een filter op te starten.',
            attachTo: {
                element: 'header-filter',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 5) {
        tour.addStep({
            title: 'Doorstart',
            text: 'Onder de doorstart kunnen URL’s van externe webpagina’s geplaatst worden. Bijvoorbeeld handleidingen, StreetSmart, Topotijdreis en DSO.',
            attachTo: {
                element: 'header-right-mouse-button',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 6) {
        tour.addStep({
            title: 'PDF-Afdruk',
            text: 'Gebruik deze knop om een PDF-afdruk te maken. De afdruk bevat de lagen of tekenen die vóór het printen zijn ingeschakeld of gemaakt. Je kunt zelf de lay-out, schaal, titel, omschrijving en legenda instellen.',
            attachTo: {
                element: 'header-print',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 7) {
        tour.addStep({
            title: ' Mededelingen',
            text: 'Het ‘belletje’ toont meldingen over KaartViewer, zoals nieuwe beschikbare lagen of gepland onderhoud. De meldingen worden beheerd door de KaartViewer-beheerder.',
            attachTo: {
                element: 'header-notifications',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 8) {
        if (!!getToken()) {
            tour.addStep({
                title: 'Profiel informatie',
                text: 'Hier vind je knoppen om naar je profiel- en accountinstellingen te gaan. Voor bijvoorbeeld het wijzigen van je wachtwoord, of het bekijken van je rechten per laag.',
                attachTo: {
                    element: 'header-logout',
                    on: 'bottom-end',
                },
                buttons: getButtons(tour, step),
            });
        } else {
            tour.addStep({
                title: 'Inloggen',
                text: 'Gebruik deze knop om in te loggen. Vaak krijg je zodra je bent ingelogd toegang tot extra kaartlagen.',
                attachTo: {
                    element: 'header-login',
                    on: 'bottom-end',
                },
                buttons: getButtons(tour, step),
            });
        }
    }

    if (!step || step === 9) {
        tour.addStep({
            title: 'Informatie over de website bekijken',
            text: 'De informatieknop opent het welkom scherm die je te zien krijgt bij de eerste keer openen van de website. Wil je die nog eens lezen of de helpfunctie starten? Gebruik dan deze knop.  Vaak vind je hier ook een handleiding.',
            attachTo: {
                element: 'header-info',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 10) {
        tour.addStep({
            title: 'Volledig scherm',
            text: 'Klik op deze knop om de KaartViewer in volledig scherm te bekijken. Tip: dit werkt hetzelfde als F11.',
            attachTo: {
                element: 'header-full-screen',
                on: 'bottom-end',

            },
            buttons: getButtons(tour, step, false, last),
        });
    }

    return tour;
}

export function stepsCatalogus(tour, step, completeTour) {
    let last = true
    let first = true

    if(completeTour) {
        first = false
        last = false
    }

    if(!step || step === 1) {
        tour.addStep({
            title: 'Catalogus',
            text: 'De catalogus bevat een verzameling kaartlagen, ingesteld door de KaartViewer-beheerder van je organisatie. Je kunt zelf lagen aan- of uitzetten en kiezen wat je nodig hebt.',
            attachTo: ({
                element: '.layer-menu',
                on: 'right',
            }),
            classes: 'ml-3',
            buttons: getButtons(tour, undefined, first),
            when: {
                show: () => {
                    const input = document.querySelector('layer-menu-switcher-button-active input');

                    if (input.checked) {
                        input.click();
                    }
                },
            }
        });

        tour.addStep({
            title: 'Alles in- en uitklappen',
            text: 'Gebruik deze knop om alle kaartlagen in een map in of uit te vouwen.',
            attachTo: {
                element: 'layer-menu-overview-collapse',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, undefined),
        });

        tour.addStep({
            title: 'Zoeken op lagen',
            text: 'De catalogus is vaak een grote verzameling aan kaartlagen. Met ‘Zoek op lagen...’ vind je snel de laag die je nodig hebt, ook door slechts een deel van de laagnaam in te typen.',
            attachTo: {
                element: 'layer-menu-search input',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, undefined),
        });

        tour.addStep({
            title: 'Catalogus groepen',
            text: 'In deze mappen zitten de lagen die aan- of uitgezet kunnen worden. Per map kun je ook alle lagen tegelijk aan- of uitzetten. Klik dan met rechtermuisknop op de map en kies een van de opties.',
            attachTo: {
                element: 'layer-menu-group',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, undefined),
        });


        tour.addStep({
            title: 'Actieve lagen',
            text: 'Bij het aanzetten van dit schuifje krijg je een overzicht van de actieve kaartlagen van de catalogus. Zo zie je in één oogopslag wat er aanstaat. Ook vind je hier een knop om zelf data toe te voegen (indien ingesteld door de beheerder) en een knop om bookmarks aan te maken met jouw favoriete kaartlagen.',
            attachTo: {
                element: 'layer-menu-switcher-button-active .switcher',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, undefined, false, last),
        });
    }

    if (!step || step === 2) {
        tour.addStep({
            title: 'Data importeren',
            text: 'Je kunt zelf data importeren in KaartViewer. Dit kan van alles zijn. Webservices zoals WMS, WFS, WMTS, XYZ, 3DTileSet. Maar ook bestanden zoals een CSV, Excel of GeoJson. Handig om snel wat data toe te voegen zonder tussenkomst van de beheerder. Wil je dat de data altijd in de KaartViewer blijft, dan moet je wel even contact met de beheerder opnemen.',
            attachTo: {
                element: 'layer-menu-add-dataset-item',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, step),
            when: {
                show: () => {
                    const input = document.querySelector('layer-menu-switcher-button-active input');

                    if (!input.checked) {
                        input.click();
                    }
                },
            }
        });
    }

    if (getToken() && (!step || step === 3)) {

        tour.addStep({
            title: 'Bookmark',
            text: 'Bookmarks gebruik je om specifieke kaartlagen op te slaan die je zelf vaak gebruikt. Dit is dus persoonsgebonden. Enkel de kaartlagen vanuit ‘Actieve lagen’ worden in een bookmark opgeslagen. Voeg een bookmark toe en geef het een naam. Vervolgens kan je een bookmark starten en stoppen.',
            attachTo: {
                element: 'layer-menu-button-session',
                on: 'bottom-end',
            },
            buttons: getButtons(tour, step, false, last),
            when: {
                show: () => {
                    const input = document.querySelector('layer-menu-switcher-button-active input');

                    if (!input.checked) {
                        input.click();
                    }
                },
            }
        });
    }

    return tour
}

export function stepsBottomButtons(tour, step, completeTour) {
    let last = true
    let first = true

    if(completeTour) {
        first = false
        last = false
    }

    if (!step || step === 1) {
        tour.addStep({
            title: 'Achtergrondkaarten',
            text: 'Klik op het kaart icoon om een andere achtergrond te selecteren. Je kunt ook de transparantie instellen. Welke achtergrondkaarten beschikbaar zijn is afhankelijk van je organisatie.',
            attachTo: ({
                element: 'ol-map-switcher button',
                on: 'bottom-end',
            }),
            classes: 'mb-2',
            buttons: getButtons(tour, step, first),
        });
    }

    if (!step || step === 2) {
        tour.addStep({
            title: 'Inzoomen',
            text: 'Gebruik deze knop om in te zoomen.',
            attachTo: {
                element: 'ol-zoom-in button',
                on: 'bottom-end',
            },
            classes: 'mb-2',
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 3) {
        tour.addStep({
            title: 'Uitzoomen',
            text: 'Gebruik deze knop om uit te zoomen op de kaart.',
            attachTo: {
                element: 'ol-zoom-out button',
                on: 'bottom-end',
            },
            classes: 'mb-2',
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 4) {
        tour.addStep({
            title: 'Zoomen via rechthoek',
            text: 'Klik op deze knop en teken een rechthoek op de kaart om in te zoomen. Tip: Dit werkt ook door SHIFT ingedrukt te houden en een vlak te tekenen op de kaart.',
            attachTo: {
                element: 'ol-drag-zoom button',
                on: 'bottom-end',
            },
            classes: 'mb-2',
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 5) {
        tour.addStep({
            title: 'Ga naar huidige locatie',
            text: 'Gebruik deze knop om je GPS-locatie in te schakelen. De eerste keer wordt gevraagd om toestemming om je locatie te gebruiken. Daarna kun je instellen in welk interval je locatie opnieuw gecentreerd wordt.',
            attachTo: {
                element: 'ol-track-location button',
                on: 'bottom-end',
            },
            classes: 'mb-2',
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 6) {
        tour.addStep({
            title: 'Vergelijken kaartlagen',
            text: 'Gebruik de slider om kaartlagen te vergelijken. Zorg ervoor dat de kaartlagen die je wilt vergelijken aan staan, zodat je ze kunt selecteren bij "Kaart links" en "Kaart rechts".',
            attachTo: {
                element: 'ol-slider button',
                on: 'bottom-end',
            },
            classes: 'mb-2',
            buttons: getButtons(tour, step),
        });
    }

    if ((!step || step === 7) && getViewProjectionName() === 'EPSG:3857') {
        tour.addStep({
            title: '3D',
            text: 'Switch van 2D weergave naar 3D en ontdek de wereld op de kaart in 3D. Gebruik Shift of ctrl in combinatie met je muis om het 3D beeld te kantelen. Let op: het kan even duren voordat de kaartlagen geladen zijn. ',
            attachTo: {
                element: 'cesium-enable button',
                on: 'bottom-end',
            },
            classes: 'mb-2',
            buttons: getButtons(tour, step, false, last),
        });
    }

    return tour;
}

export function stepsRightButtons(tour, step, completeTour) {
    let first = true

    if (completeTour) {
        first = false
    }

    if (!step || step === 1) {
        tour.addStep({
            title: 'Kenmerken',
            text: 'Hier vind je de kenmerken van de kaartlaag, zoals het instellen van transparantie en laagvolgorde, het centreren van de kaart, de schaal, de DataPortaal-weergave en de metadata.',
            attachTo: ({
                element: 'layer-info-characteristics-button .info-menu-btn',
                on: 'left-start',
            }),
            classes: 'mr-3',
            highlightClass: 'active',
            buttons: getButtons(tour, step, first),
        });
    }

    if (!step || step === 2) {
        tour.addStep({
            title: 'Informatie',
            text: 'Bekijk hier het informatieformulier van een object op de kaart. Klik eerst op een object om het weer te geven.',
            attachTo: ({
                element: 'layer-info-info-button .info-menu-btn',
                on: 'left-start',
            }),
            classes: 'mr-3',
            highlightClass: 'active',
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 3) {
        tour.addStep({
            title: 'Filteren',
            text: 'Deze knop is zichtbaar zodra filters beschikbaar zijn in de website. Het filterformulier wordt geopend wanneer je een filter aanklikt in de catalogus of bij de favoriete filters. Soms vind je hier ook een lijst van alle filters, afhankelijk van de instellingen van de beheerder.',
            attachTo: ({
                element: 'layer-info-filter-button .info-menu-btn',
                on: 'left-start',
            }),
            classes: 'mr-3',
            highlightClass: 'active',
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 4) {
        tour.addStep({
            title: 'Muteren',
            text: 'Deze knop verschijnt zodra er een mutatieformulier beschikbaar is in de website. Het formulier wordt geopend wanneer je een muteerbare laag in de catalogus aanzet. Soms vind je hier een lijst van alle mutatieformulieren van de website, afhankelijk van de instellingen van de beheerder.',
            attachTo: ({
                element: 'layer-info-mutation-button .info-menu-btn',
                on: 'left-start',
            }),
            classes: 'mr-3',
            highlightClass: 'active',
            buttons: getButtons(tour, step),
        });
    }

    if (!step || step === 5) {
        const last = !isVisibleBySelector('layer-info-legend-button');

        tour.addStep({
            title: 'Tekenen en meten',
            text: 'Hier vind je de teken- en meetfunctionaliteiten. Je kunt vlakken, lijnen en cirkels tekenen, teksten plaatsen, kleuren aanpassen en maatvoeringen bekijken. Deze verdwijnen weer zodra je de pagina ververst. Tip: je kunt je tekening ook als PDF afdrukken.',
            attachTo: ({
                element: 'layer-info-tools-button .info-menu-btn',
                on: 'left-start',
            }),
            classes: 'mr-3',
            highlightClass: 'active',
            buttons: getButtons(tour, step, false, last),
        });
    }


    if ((!step || step === 6) && isVisibleBySelector('layer-info-legend-button')) {
        tour.addStep({
            title: 'Legenda',
            text: 'Sommige kaartlagen hebben een legenda. Als die beschikbaar is, kun je deze hier bekijken!',
            attachTo: ({
                element: 'layer-info-legend-button .info-menu-btn',
                on: 'left-start',
            }),
            classes: 'mr-3',
            highlightClass: 'active',
            buttons: getButtons(tour, step, false, true),
        });
    }

    return tour;
}

function stepCompleteTour(tour) {
    tour.addStep({
        title: 'Welkom bij de KaartViewer help doorloop',
        text: 'Gebruik de knoppen of de pijltjes <span class="fa fa-arrow-left"></span> en <span class="fa fa-arrow-right"></span> op je toetsenbord om langs alle knoppen van de KaartViewer te gaan.',
        buttons: getButtons(tour, undefined, true),
    });

    return tour;
}

function getButtons(tour, step = undefined, first = false, last = false) {

    if (step) {
        return [{
            text: 'Sluiten',
            secondary: true,
            action: tour.next,
            classes: 'btn btn-outline-secondary',
        }]
    }

    if (last) {
        return [
            {
                action: tour.back,
                secondary: true,
                text: 'Vorige',
                classes: 'btn btn-outline-secondary',
            },
            {
                text: 'Sluiten',
                action: tour.next,
                secondary: true,
                classes: 'btn btn-outline-secondary',
            }
        ]
    }

    if (first) {
        return [
            {
                text: 'Volgende',
                secondary: true,
                action: tour.next,
                classes: 'btn btn-outline-secondary',
            },
        ]
    }

    return [
        {
            action: tour.back,
            text: 'Vorige',
            secondary: true,
            classes: 'btn btn-outline-secondary'
        },
        {
            text: 'Volgende',
            action: tour.next,
            secondary: true,
            classes: 'btn btn-outline-secondary',
        }
    ]
}
